import { Typography } from "@kyan/ui";

export interface SlideHeadingProps {
  title: string;
  description?: string;
}

export const SlideHeading: React.FC<SlideHeadingProps> = ({
  title,
  description,
}) => {
  return (
    <div className="flex h-16.5 flex-col items-center justify-center gap-1 p-4">
      <Typography primary size={16}>
        {title}
      </Typography>
      {description && <Typography>{description}</Typography>}
    </div>
  );
};
